import type { FaireProductEntity } from "../../entity_types/product";

export const p_f6mz2ksjsm: FaireProductEntity = {
  token: "p_f6mz2ksjsm",
  type: "product",
  name: "Mushroom mug with purple and blue glaze",
  brandToken: "b_qpb3ygknfs",
  brandName: "Divine Vessels Pottery",
  imageUrl:
    "https://cdn.faire.com/fastly/79507d52c38a0125633779bcfbe9a18358205c60f9c81d0baeb55a94df50ba36.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/105e7dd579b6e094cd7e8687ec87abb064da415442afd232c4a0922f62bf20be.jpeg",
    "https://cdn.faire.com/fastly/0e4192a8f8b81847e56036754034040d40ca518eef87982648496733e3fcde90.jpeg",
    "https://cdn.faire.com/fastly/8dc3c99942f34dc511396b3ff01a44d8099c812e1d5bac807ce29e62418a0ef7.jpeg",
    "https://cdn.faire.com/fastly/0c522d8f3b0b369c8cbcb4c57e59a8f060ef2cd328961dcfb2a909f04242e5ca.jpeg",
    "https://cdn.faire.com/fastly/a84a6c695cfd58562f7b5c721add9855550ac5328955400ebe35c9f4d192723c.jpeg",
    "https://cdn.faire.com/fastly/1e2c336cadfe91979e8f73e1bb32203b204c2446be36c95d69f38117571d280e.jpeg",
  ],
  priceDollars: 31.87,
  description:
    "This expertly crafted mug showcases a mesmerizing blue and purple glaze, highlighted by a magical white emblem of a mushroom. Designed for both aesthetic appeal and everyday use, it offers a comfortable grip and durable finish, making it an ideal choice for those who appreciate unique, artisanal drinkware.\n\n* Holds 12 oz. \n* Handmade in the USA\n* Woman owned business \n* Each piece is carefully handcrafted by the artist so there are slight variations from the                      item pictured. \n* This is stoneware pottery known for its rugged qualities\n* Dishwasher, microwave and oven safe. \n\n",
  tags: [],
  msrpDollars: 63.74,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:32.174Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
